import React, { createContext, useContext } from 'react';

// ---- Config context (rarely changes) ----
// Message state is passed to `MainContent` as props; only the static config
// needs a context so deep children (MessageBubble, OrderCardsMessage) can read it.
export interface ChatConfigValue {
  enableToolVisualization: boolean;
  enableSourceCitations: boolean;
  enableThinking: boolean;
  showTimestamps: boolean;
  trackAnalytics: (action: string, data: Record<string, unknown>) => void;
}

const ChatConfigContext = createContext<ChatConfigValue | null>(null);

export function ChatConfigProvider({
  value,
  children,
}: {
  value: ChatConfigValue;
  children: React.ReactNode;
}) {
  return <ChatConfigContext.Provider value={value}>{children}</ChatConfigContext.Provider>;
}

export function useChatConfig(): ChatConfigValue {
  const ctx = useContext(ChatConfigContext);
  if (!ctx) throw new Error('useChatConfig must be used within a ChatConfigProvider');
  return ctx;
}

export function useOptionalChatConfig(): ChatConfigValue | null {
  return useContext(ChatConfigContext);
}
